import {Directive, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output} from '@angular/core'

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[clickOutside]',
    standalone: false
})
export class OpcoesTableControlDirective implements OnInit, OnDestroy {

    // Quando false o clique no documento é ignorado sem disparar change detection
    @Input() clickOutsideEnabled = true;
    @Output() clickOutside = new EventEmitter();

    private listener = (e: Event) => {
        if (!this.clickOutsideEnabled) return
        if (!this.el.nativeElement.contains(e.target)) {
            this.zone.run(() => this.clickOutside.emit(null))
        }
    }

    constructor(private el: ElementRef, private zone: NgZone) {
    }

    ngOnInit() {
        this.zone.runOutsideAngular(() => document.addEventListener('click', this.listener))
    }

    ngOnDestroy() {
        document.removeEventListener('click', this.listener)
    }
}
